export default __webpack_public_path__ + "static/media/forbidden-pricing.51bb3eda.svg";